import { render } from "./RouteStops.vue?vue&type=template&id=ff6b5ca4"
import script from "./RouteStops.vue?vue&type=script&lang=js"
export * from "./RouteStops.vue?vue&type=script&lang=js"

import "./RouteStops.vue?vue&type=style&index=0&id=ff6b5ca4&lang=css"

import exportComponent from "/buddy/denhaagfietst-sterfietsroutes/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__